import { useState, useEffect } from 'react'
import { maps } from '../Services/GoogleMaps'

export default function useGoogleMaps() {
    const [api, setApi] = useState(maps.instance)
    useEffect(() => {
        if (!api) {
            maps.promise.then(setApi)
        }
    }, [api])
    return api
}
